export function FeaturesSection() {
  const features = [
    {
      icon: 'ri-brain-line',
      title: 'AI智能写作',
      description: '输入主题或关键词，AI自动生成高质量文章，支持多种文体和风格，满足各类创作场景需求。',
      color: 'primary' as const,
    },
    {
      icon: 'ri-edit-2-line',
      title: '文章润色优化',
      description: '智能语法检测和风格优化，让你的文字表达更加流畅自然，提升文章整体质量。',
      color: 'accent' as const,
    },
    {
      icon: 'ri-list-check-2',
      title: '大纲自动生成',
      description: '输入主题即可生成结构化文章大纲，帮助你理清思路，高效组织内容框架。',
      color: 'secondary' as const,
    },
    {
      icon: 'ri-translate-2',
      title: '多语言翻译',
      description: '支持中英日韩等十余种语言互译，确保翻译准确且符合本地化表达习惯。',
      color: 'primary' as const,
    },
    {
      icon: 'ri-team-line',
      title: '团队协作编辑',
      description: '支持多人实时协作编辑，评论审阅，权限管理，让团队创作更加高效顺畅。',
      color: 'accent' as const,
    },
    {
      icon: 'ri-history-line',
      title: '版本历史管理',
      description: '自动保存编辑记录，支持任意版本回溯和对比，再也不用担心误删内容。',
      color: 'secondary' as const,
    },
  ];

  const colorMap = {
    primary: { bg: 'bg-primary-50', icon: 'text-primary-600' },
    accent: { bg: 'bg-accent-50', icon: 'text-accent-600' },
    secondary: { bg: 'bg-secondary-50', icon: 'text-secondary-600' },
  };

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            核心功能
          </h2>
          <p className="mt-3 text-foreground-500 text-sm max-w-lg mx-auto">
            一起草提供全方位的AI内容创作工具，覆盖从灵感到成品的每一个环节
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-50 border border-background-200/70 rounded-xl p-6 hover:border-background-300/60 transition-all duration-200 group cursor-pointer"
            >
              <div className={`w-11 h-11 ${colorMap[feature.color].bg} rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                <i className={`${feature.icon} ${colorMap[feature.color].icon} text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}